var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { createUIElement } from "../helpers";
export var SeparatorInner = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    height: 1px;\n    background-color: ", ";\n    margin: ", ";\n"], ["\n    position: relative;\n    width: 100%;\n    height: 1px;\n    background-color: ", ";\n    margin: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.borders.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.s + " 0 " + theme.spacing.s + " 0";
});
var StyledTr = styled.tr(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    display: table-row;\n    > td {\n        width: 100%;\n    }\n"], ["\n    position: relative;\n    display: table-row;\n    > td {\n        width: 100%;\n    }\n"])));
export var Separator = createUIElement('Separator', function (_a, ref) {
    var className = _a.className, style = _a.style, rest = __rest(_a, ["className", "style"]);
    return (React.createElement(StyledTr, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-Separator " + className, ref: ref, style: style }),
        React.createElement("td", { colSpan: 2 },
            React.createElement(SeparatorInner, null))));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Separator.js.map